import { useEffect, useState } from 'react';
import { getNotifications, subscribe } from '../utils/notifications';

export const useNotifications = () => {
  const [notifications, setNotifications] = useState(() => getNotifications());

  useEffect(() => {
    setNotifications(getNotifications());
    const unsubscribe = subscribe(setNotifications);
    return unsubscribe;
  }, []);

  const unreadCount = notifications.filter(n => !n.readAt).length;
  return { notifications, unreadCount };
};
